import { Form, FormGroup, InputGroup } from 'react-bootstrap';
import { CardHandler, DictionaryData, Language } from '../../types/Common';
import useOnChange from '../general/OnChange';
import { Link } from 'react-router-dom';

export default function DicEditor(props: {
    dictionary: DictionaryData,
    languages: Language[],
    cardHandlers?: CardHandler[],
    onChange(data: DictionaryData): void
}) {
    const { onStringChange, onNumberChange, onBooleanChange } = useOnChange(props.dictionary, props.onChange);

    return (
        <>
            <FormGroup>
                <Form.Label htmlFor="name">Name</Form.Label>
                <Form.Control id="name"
                    value={props.dictionary.name || ''}
                    className="fs-3"
                    onChange={onStringChange} />
            </FormGroup>

            <div className="my-3">
                <FormGroup>
                    <Form.Label htmlFor="phraseLanguageId">Phrase language</Form.Label>

                    <InputGroup>
                        <Form.Select id="phraseLanguageId"
                            value={props.dictionary.phraseLanguageId || 0}
                            onChange={onNumberChange}>
                            <option></option>
                            {props.languages.map(l =>
                                <option value={l.id} key={l.id}>{l.name}</option>)}
                        </Form.Select>

                        <Link className="btn btn-outline-primary px-1 px-sm-2"
                            to={`/languages/${props.dictionary.phraseLanguageId || ''}`}>
                            Open
                        </Link>
                    </InputGroup>

                </FormGroup>

                <FormGroup>
                    <Form.Label htmlFor="meaningLanguageId">Meaning language</Form.Label>

                    <InputGroup>
                        <Form.Select id="meaningLanguageId"
                            value={props.dictionary.meaningLanguageId || 0}
                            onChange={onNumberChange}>
                            <option></option>
                            {props.languages.map(l =>
                                <option value={l.id} key={l.id}>{l.name}</option>)}
                        </Form.Select>

                        <Link className="btn btn-outline-primary px-1 px-sm-2"
                            to={`/languages/${props.dictionary.meaningLanguageId || ''}`}>
                            Open
                        </Link>
                    </InputGroup>
                </FormGroup>

                <FormGroup>
                    <Form.Label htmlFor="reversoToLanguageId">Reverso translation language</Form.Label>

                    <InputGroup>
                        <Form.Select id="reversoToLanguageId"
                            value={props.dictionary.reversoToLanguageId || 0}
                            onChange={onNumberChange}>
                            <option></option>
                            {props.languages.map(l =>
                                <option value={l.id} key={l.id}>{l.name}</option>)}
                        </Form.Select>

                        <Link className="btn btn-outline-primary px-1 px-sm-2"
                            to={`/languages/${props.dictionary.reversoToLanguageId || ''}`}>
                            Open
                        </Link>
                    </InputGroup>
                </FormGroup>
            </div>


            {props.cardHandlers &&
                <FormGroup>
                    <Form.Label htmlFor="cardHandlerId">Default card beautifier</Form.Label>
                    <Form.Select id="cardHandlerId"
                        className="py-1"
                        value={props.dictionary.cardHandlerId || ''}
                        onChange={onNumberChange}>
                        <option></option>
                        {props.cardHandlers.map(l =>
                            <option value={l.id} key={l.id}>{l.name}</option>)}
                    </Form.Select>
                </FormGroup>}

            <Form.Group controlId="choiceTrainingAvailable">
                <Form.Check type="checkbox"
                    label="'Choose the right variant' mode enabled"
                    className="text-start mt-2"
                    checked={props.dictionary.choiceTrainingAvailable}
                    onChange={onBooleanChange} />
            </Form.Group>
        </>
    )
}
